import { MessageCircle, Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { PHONE_TEL, openWa } from "@/lib/wa";
import { useLang } from "@/context/LanguageContext";

export default function FloatingActions() {
  const { pathname } = useLocation();
  const { t } = useLang();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div className="fixed bottom-5 z-40 flex flex-col gap-3" style={{ insetInlineStart: "1.25rem" }}>
      <motion.button
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1, type: "spring" }}
        onClick={() => openWa()}
        data-testid="floating-whatsapp-button"
        aria-label="WhatsApp"
        className="flex h-14 w-14 animate-pulse-gold items-center justify-center rounded-full bg-[#1FAF5A] text-white shadow-2xl shadow-black/50 transition-transform hover:scale-110"
      >
        <MessageCircle size={26} />
      </motion.button>
      <a
        href={PHONE_TEL}
        data-testid="floating-call-button"
        aria-label={t("cta.call")}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-ink shadow-2xl shadow-black/50 transition-transform hover:scale-110 md:hidden"
      >
        <Phone size={24} />
      </a>
    </div>
  );
}
